import React, { createContext, useContext, useState } from 'react';

interface AuthContextType {
  user: any | null;
  signIn: (email: string, password: string) => Promise<void>;
  signUp: (email: string, password: string) => Promise<void>;
  signOut: () => Promise<void>;
  resetPassword: (email: string) => Promise<void>;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [user, setUser] = useState<any | null>(null);

  const signIn = async (email: string, password: string) => {
    console.log('Sign in:', email);
  };

  const signUp = async (email: string, password: string) => {
    console.log('Sign up:', email);
  };

  const signOut = async () => {
    setUser(null);
  };

  const resetPassword = async (email: string) => {
    console.log('Reset password:', email);
  };

  return (
    <AuthContext.Provider value={{ user, signIn, signUp, signOut, resetPassword }}>
      {children}
    </AuthContext.Provider>
  );
}
